import { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import Modal from '../../modal/Modal';
import Button from '../../button/Button';
import TextInput from '../../inputs/text-input/TextInput';
import Thumbnails from '../../thumbnails/Thumbnails';
import FilePicker from '../../inputs/file-picker/FilerPicker';

import { ReactComponent as AttachmentIcon } from '../../../../resources/icons/attachment.svg';

import './comment-edit-modal.scss';

const CommentEditModal = ({ comment, show, setShow, updateComment }) => {
  const [text, setText] = useState('');
  const [images, setImages] = useState([]);

  const fileRef = useRef(null);

  useEffect(() => {
    if (comment && show) {
      setText(comment.text);
      setImages(comment.linkedMediaReferences);
    }
  }, [comment, show]);

  const handleFileChange = ({ target }) => {
    const file = target.files[0];
    setImages([...images, file]);
  };

  const deleteImage = (index) => {
    const newImages = [...images];
    newImages.splice(index, 1);
    setImages(newImages);
  };

  const handleSaveClick = () => {
    updateComment(text, images, () => {
      setText('');
      setImages([]);
      setShow(false);
    });
  };

  return (
    <Modal show={show} setShow={setShow}>
      <section className="comment-edit-modal">
        <div className="comment-edit-modal__header">
          <p className="comment-edit-modal__title">Edit Comment</p>
        </div>
        <div className="comment-edit-modal__content">
          <div className="comment-edit-modal__input-container">
            <TextInput
              className="comment-edit-modal__input"
              value={text}
              placeholder="Comment..."
              onChange={({ target }) => setText(target.value)}
              multiline
            />
          </div>
          <Thumbnails images={images} deleteImage={deleteImage} />
          <div className="comment-edit-modal__actions">
            <FilePicker
              fileRef={fileRef}
              enableFileLimit={true}
              triggerElement={
                <AttachmentIcon className="comment-edit-modal__icon" onClick={() => fileRef.current.click()} />
              }
              onChange={handleFileChange}
            />
            <div className="comment-edit-modal__buttons">
              <Button className="comment-edit-modal__button" onClick={() => setShow(false)} secondary>
                CANCEL
              </Button>
              <Button className="comment-edit-modal__button" onClick={handleSaveClick}>
                SAVE
              </Button>
            </div>
          </div>
        </div>
      </section>
    </Modal>
  );
};

CommentEditModal.propTypes = {
  comment: PropTypes.shape({}).isRequired,
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  updateComment: PropTypes.func.isRequired,
};

export default CommentEditModal;
